export default "__VITE_ASSET__BxOj46E0__"